import { PriceEvolutionResponse } from '@/models/queries/getPriceEvolution';
import { PriceRoomDistribution } from '@/models/queries/getPriceRoomDistribution';
import { PriceValueResponse } from '@/models/queries/getPriceValue';
import { KpiTypeValue, PropertyType } from '@/types';
import { captureError } from '@smg-real-estate/browser-rum';
import { create } from 'axios';

export const iaziClient = create({
  baseURL: import.meta.env.VUE_APP_MARKET_ATLAS_ENDPOINT,
});

interface LevelProps {
  level: number;
  levelId: number;
}

interface PriceValueProps extends LevelProps {
  kpiType?: KpiTypeValue;
}

export const getPriceValue = async ({
  kpiType = KpiTypeValue.PricePerSquareMeter,
  level,
  levelId,
}: PriceValueProps): Promise<PriceValueResponse> => {
  const baseUrl = `/v1/pricevalue`;
  const queryParams = `KpiType=${kpiType}&Level=${level}&LevelId=${levelId}`;

  try {
    const response = await iaziClient.post('/', {
      path: baseUrl,
      queryParams,
    });

    return response.data;
  } catch (error) {
    captureError(error);
    return null;
  }
};

export const getPriceEvolution = async ({
  level,
  levelId,
}: LevelProps): Promise<PriceEvolutionResponse> => {
  const baseUrl = `/v1/priceevolution`;
  const queryParams = `Level=${level}&LevelId=${levelId}`;

  try {
    const response = await iaziClient.post('/', {
      path: baseUrl,
      queryParams,
    });

    return response.data;
  } catch (error) {
    captureError(error);
    return null;
  }
};

export const getPriceRoomDistribution = async ({
  level,
  levelId,
}: LevelProps): Promise<PriceRoomDistribution> => {
  const baseUrl = `/v1/priceroomdistribution`;
  const queryParams = `Level=${level}&LevelId=${levelId}`;

  try {
    const response = await iaziClient.post('/', {
      path: baseUrl,
      queryParams,
    });

    return response.data;
  } catch (error) {
    captureError(error);
    return {
      results: {
        roomsListApartment: null,
        roomsListHouse: null,
        [PropertyType.Apartment]: null,
        [PropertyType.House]: null,
      },
    };
  }
};
